module.exports = __webpack_public_path__ + "static/img/playerPositionbg.9820dfbe.svg";